import angular from 'angular';

import Component from './duration-input.component';

const Module = angular
    .module('control-room.commons.basic.components.duration-input', [])
    .component('crDurationInput', Component);

export default Module;
